import { MoveMessageTemplateParams } from 'types/services';

export const moveMessageTemplate = async (
  params: MoveMessageTemplateParams
) => {};
